<i2g-dialog-base
  *ngIf="activeScreen === 0"
  [title]="title | translate"
  [body]="body | translate"
>
  <i2g-notification
    top
    *ngIf="notification"
    notificationStyle="alert"
    [showDismissIcon]="false"
    [message]="'SETTINGS.UPDATE_EMAIL_DIALOG.SMS_RATE_LIMIT' | translate"
  ></i2g-notification>

  <i2g-select-field
    [label]="'LABEL.COUNTRY' | translate"
    [fieldControl]="countryControl"
    [options]="countryAutocompleteOptions"
    layoutDirection="column"
    [disabled]="!allowCountryChange"
    (selectOption)="phoneControl.updateValueAndValidity()"
  >
  </i2g-select-field>

  <i2g-input-field
    class="phone-field"
    layoutDirection="column"
    placeholder="123 456 7890"
    type="tel"
    [autocomplete]="I2gInputFieldAutocompleteType.telNational"
    [errorMessages]="{ pattern: { message: 'ERROR.INVALID_PHONE_NUMBER' } }"
    [focusableTrigger$]="phoneFocusTrigger.asObservable()"
    [fieldControl]="phoneControl"
    [label]="'LABEL.MOBILE' | translate"
    (keyup.enter)="!(phoneControl.invalid || isProcessing) && onNextClicked()"
  >
  </i2g-input-field>

  <div class="buttons-row">
    <button
      i2gButton
      buttonStyle="emphasis"
      [disabled]="phoneControl.invalid || isProcessing"
      i2gTrackable="next"
      (click)="onNextClicked()"
    >
      <i2g-icon
        *ngIf="isProcessing"
        class="loading-icon"
        name="loading-spinner"
        size="custom"
      >
      </i2g-icon>
      {{ (isProcessing ? 'LABEL.SENDING' : 'ACTION.NEXT') | translate }}
    </button>
    <button
      i2gButton
      buttonStyle="default"
      i2gTrackable="cancel"
      (click)="onCancelClicked()"
    >
      {{ 'ACTION.CANCEL' | translate }}
    </button>
  </div>
</i2g-dialog-base>

<i2g-dialog-base
  *ngIf="activeScreen === 1"
  [title]="'SETTINGS.UPDATE_EMAIL_DIALOG.TITLE_1' | translate"
  [body]="
    'SETTINGS.UPDATE_EMAIL_DIALOG.DESCRIPTION_1'
      | translate: { phoneNumber: phoneWithDialingCode }
  "
>
  <!-- sms blocked notification takes precedence over sent/resent notification -->
  <i2g-notification
    top
    *ngIf="notification"
    [notificationStyle]="
      ['CODE_BLOCKED', 'SMS_RATE_LIMIT'].includes(notification)
        ? 'alert'
        : 'info'
    "
    [showDismissIcon]="false"
    [message]="'SETTINGS.UPDATE_EMAIL_DIALOG.' + notification | translate"
  ></i2g-notification>

  <i2g-input-field
    class="code"
    layoutDirection="column"
    label="Verification code"
    maxlength="6"
    [autocomplete]="I2gInputFieldAutocompleteType.mfaCode"
    [fieldControl]="codeControl"
    [focusableTrigger$]="codeFocusTrigger.asObservable()"
    [errorMessages]="{
      invalid: { message: 'SETTINGS.UPDATE_EMAIL_DIALOG.INVALID_CODE' },
      expired: { message: 'SETTINGS.UPDATE_EMAIL_DIALOG.EXPIRED_CODE' }
    }"
    (keyup.enter)="!isProcessing && onConfirmClicked()"
  ></i2g-input-field>

  <p class="did-not-receive">
    {{ 'SETTINGS.UPDATE_EMAIL_DIALOG.DIDNT_RECEIVE' | translate }}
  </p>
  <div class="actions-row">
    <a i2gTrackable="send_sms" (click)="resendSms()">{{
      'SETTINGS.UPDATE_EMAIL_DIALOG.SEND_SMS' | translate
    }}</a>
    <!-- TODO: pending option for voice verification -->
  </div>

  <div class="buttons-row">
    <button
      i2gButton
      buttonStyle="emphasis"
      i2gTrackable="confirm"
      [disabled]="isProcessing"
      (click)="onConfirmClicked()"
    >
      <i2g-icon
        *ngIf="isProcessing"
        class="loading-icon"
        name="loading-spinner"
        size="custom"
      >
      </i2g-icon>
      {{
        (isProcessing
          ? 'SETTINGS.UPDATE_EMAIL_DIALOG.VERIFYING'
          : 'ACTION.CONFIRM'
        ) | translate
      }}
    </button>
    <button
      i2gButton
      buttonStyle="default"
      i2gTrackable="back"
      (click)="onBackClicked()"
    >
      {{ 'ACTION.BACK' | translate }}
    </button>
  </div>
</i2g-dialog-base>
